<template>
<div id='cartDetail'>
<buyPlan  ref="edit" />
<GoodsShortage v-if='selloutShow' :goodsMsg='selloutMsg'  @selloutShowFN="getMsgFormSellout"/>
<Alert  v-if='AlertShow' :alertMsg='alertMsg' />
<plugin />
<div class='jdTopTips' v-if='cartInfo.source==3'>
	            <div class='jdTopTipsTxt'>此橘袋为好友的报告方案，不可调整</div>
	      </div>
	      <div class='jdTopTips' v-if='cartInfo.source==2'>
	            <div class='jdTopTipsTxt'>此橘袋为营养师搭配套餐，不可调整</div>
	      </div>
	       <div class='jdTopTips' v-if='cartInfo.source==1&&cartInfo.status!=1'>
	            <div class='jdTopTipsTxt'>此橘袋为孕产妇报告方案，不可调整</div>
	      </div>
<div class='jdPage' >
	
		
      <div class='jdHead'>
          <div class='jdHeadTop'>  
                <div class='jdName' @click="changCartName">{{cartInfo.name}}
                        <img src='../assets/icon-edit.png' v-if='cartInfo.source!=2'></img>
                 </div>
                <div class='jdTime'>{{cartInfo.create_time}}</div>
          </div>
          <!-- 报告、自购 -->
          <div class='jdHeadMid'  v-if='cartInfo.source!=2' @click='upPlan'><span>{{cartInfo.plan_title}}</span>
                <img src='../assets/2@2x.png' v-if='cartInfo.source!=2'></img>
          </div> 
          <!-- 套餐 -->
          <div class='jdHeadMid2'  v-if='cartInfo.source==2'>
                <div class='mealbuyday'>{{cartInfo.buy_days}}天装</div>
                <div class='mealBtn' @click="cutMealNum(cartInfo.id,cartInfo.num)" >
                       <img src='../assets/jian.png'></img>
                </div>
                <div class='mealNumBox'><input type="number" :value="cartInfo.num" maxlength='2' @keyup.enter='changeMealNum' @blur.prevent='changeMealNum' :data-cartid='cartInfo.id'></input></div>
                <div class='mealBtn'  @click="addMealNum(cartInfo.id,cartInfo.num)" >
                        <img src='../assets/jia.png'></img>
                </div>
          </div>
          <div  class='jdHeadBottom'>当前方案： 每日{{cartInfo.jdType }}种， 共{{cartInfo.jdNum}}颗</div>
      </div>
      <div class='jdGoodsBox'>
          <div   v-for='item in cartInfo.goods_info'>
              <div class='jdGoodsRow' :class='item.showDelete?"cartDel":""'  v-if='!item.del' bindtouchstart='touchStart' bindtouchend="touchEnd" :data-id='item.goods_id' >

                    <div class='cover' v-if='item.status==3'></div>

                    <!-- <div class='delBtn' :data-id='item.goods_id'  :data-status='item.status' :data-stockmark='item.stockMark' :data-num='item.goods_num'>
                    <img src='../assets/icon-delete3.png'></img>
                    删除</div> -->
                    <img class='jdGoodsRowImg' :src='item.minshrink_img'></img>
                    <div class='jdGoodsRowTitle'>
                          <div class='jdGoodsRowTxt'>
                              <div class='jdGoodsRowName'>{{item.goods_name}}</div>
                              <div class='jdGoodsRowUse' >{{item.goods_num}} 颗/天  <span v-if='item.status==3' style='color:rgba(194,94,77,1);'>已售罄</span><span v-if='item.status==4' style='color:rgba(194,94,77,1);'>已下架</span></div>
                               
                              <div class='goodsRemarks' v-if='item.status==2'>{{item.advance_sale_remarks}}</div>
                          </div>
                          <div class='jdGoodsRowPrice' v-if='cartInfo.source!=2'><span >{{item.goodsPrice}}</span>元/月</div>
                          <div class='jdGoodsRowPrice' v-if='cartInfo.source==2'><span>{{item.goodsPrice}}</span>元/套</div>     
                    </div>
                    
              </div>
              <div class='nullGoods' :class='item.nullShow ?"nullGoods2":""'  v-if='item.del'></div>
          </div>
      </div> 
      <!-- <div class='jdAddGoods' v-if='cartInfo.status==1&&cartInfo.source!=3' bindtap="jdAddOtherGoods">
            <img  src='../assets/addGoods.png'  class='jdAddGoodsImg'></img>
            <div  class='jdAddGoodsTxt'>添加其它产品</div>
      </div> -->
      <div class='jdTitle'>*为规避如药物营养素相互作用（DNIs）等风险，建议你在营养师或医师指引下进行自定义补剂搭配</div>
      <div style='height:1.5rem;'></div>
      <div class="jdBottom">
            <div class="jdBottomPayBox">
                <div class='jdBottomPay'>合计<span> ￥</span>{{cartInfo.pay_price||"0"}}<span v-if='cartInfo.totalPrice!=cartInfo.pay_price' style='color:rgba(20, 20, 20, 0.8);margin-left:0.05rem; text-decoration: line-through;'>￥{{cartInfo.totalPrice}}</span></div>
                <div class='jdBottomPayTxt'>保税区免费直邮</div>
            </div>
            <div class='jdBottomBtn' style='background:rgba(207, 207, 207, 1);color:rgba(20, 20, 20, 1);' v-if='!buyShow' bindtap="checkReason" >结算</div>
      
            <div class='jdBottomBtn' @click="toCreateOrder" v-else>结算</div>
           
       </div>
</div>
<div class='changName' v-if='changeNameShow'>
	<div class='changNamemask' @click='closeChangeName' ></div>
	<div class='changNameBox' >
	      <div class='changNameBoxName'>修改橘袋名</div>
	      <div class='changNameBoxTxt'>你可以在这里修改橘袋名~</div>
	      <input v-model="newName" class='inputBox' placeholder="请在此输入…" maxlength="8" ></input>
	      <div class='changNameBtn1' @click='changeName' >确定</div>
	      <div class='changNameBtn2' @click='closeChangeName'>取消</div>
	</div>
</div>




 

    
  </div>
</template>

<script>
import buyPlan from '@/components/buyPlan.vue'
import Alert from '@/popup/Alert.vue'
import GoodsShortage from '@/popup/goodsShortage.vue'
import plugin from '@/components/plugin.vue'
export default {
  name: 'cartDetail',
  components: {
	  buyPlan,
	  Alert,
	  plugin,
	  GoodsShortage
  },
  data:function () {
    return{
     cartInfo:{},
     buyShow:false,
	 AlertShow:false,
	 alertMsg:"",
	 selloutShow:false,
	 selloutMsg:{},
	 cartid:"",
	 changeNameShow:false,
	 newName:"",
    }
  },
  created:function(){
   this.cartid = this.$route.params.cartid
   this.getCartOne()
  },
  
  methods: {
    // 获取橘袋详情
	
   getCartOne(){
	   
	   if(!this.cartid){
		   this.$router.go(-1)
		   return
	   }
      this.axios({
                  method: 'post',
                  url:"Allcart/getCartOne",
                  data:{
                     cart_id:this.cartid
                  }
                }).then(res=>{
                      if(!res.data.cart)return
                      console.log(res)
                      this.computeCartDetail(res.data.cart)
                })
    },
    // 计算橘袋详情
    computeCartDetail(options){
        let _jdNum = 0
        let _jdType = 0
        let _payPrice = 0
        let _stockMark = true
        options.create_time = options.create_time.split(" ")[0]
        options.goods_info.forEach((item) => {
          item.goodsPrice = Number(item.goods_price) * 30 * Number(item.goods_num)
          if (options.source == 2){
            item.goodsPrice = Number(item.goods_price) * Number(options.buy_days) * Number(item.goods_num)
          }
          item.goodsPrice = Number(item.goodsPrice)
          _jdType++
          _jdNum += Number(item.goods_num)
          _payPrice += Number(item.goods_num) * Number(item.goods_price)
          if (item.status==1){
            if (Number(item.goods_num) * Number(options.buy_days) > Number(item.goods_stock)) {
              _stockMark = false
              item.stockMark = true
            }
          }
          
        })
        options.jdNum = _jdNum
        options.jdType = _jdType
        options.totalPrice = _payPrice * Number(options.buy_days) * Number(options.num)
        options.pay_price = _payPrice * Number(options.plan_discount) * Number(options.buy_days) * Number(options.meal_discount) * Number(options.num)
        options.pay_price = Number(options.pay_price)
        options.pay_price = options.pay_price.toFixed(2)
        options.totalPrice = Number(options.totalPrice)
        options.totalPrice=options.totalPrice.toFixed(2)
        
        if (options.name.length>8){
          options.name = options.name.substring(0, 7) + "…"
        }
        this.cartInfo= options
       
     
        if (options.source == 0){       //自选
          if (options.goods_info.length > 2 && options.goods_info.length<9){
            this.buyShow = true
            
          }else{
            this.buyShow =  false
           
          }
        } else if (options.source == 1){      //报告
            if ((options.goods_info.length > 2 || options.goods_info.length >= options.product_num) && options.goods_info.length < 9) {
             this.buyShow = true
            }else{
             this.buyShow =  false
            }
        }else{
         this.buyShow = true
        }
        // if (!_stockMark){
        //   this.buyShow =  false
        // }
    },
	// 更改购买方案后更新购物车
	 updateCartList: function (cartid, payMoney, buyday, buyTitle, originalMoney,buyImg){
	    let _cartList = this.cartList
	      _cartList.forEach((item)=>{
	        if (item.id == cartid){
	          item.buy_days = buyday
	          item.totalPrice = payMoney
	          item.originalPrice = originalMoney
	          item.plan_title = buyTitle
	          item.img = buyImg
	        }
	      })
		this.cartList = _cartList
	    this.computerSlect()
	  },
	  // 输入套餐数量
	    changeMealNum:function(e){
		
		  let that = this
	      let _num = Number(e.target.value)
	      if (_num < 1) {
	        _num = 1
	      }
	      if (_num > 99) {
	        _num = 99
	      }
			
	      that.$refs.edit.editCartNum(e.srcElement.dataset.cartid, _num).then((res)=>{
	        if(res.data.code==2){
				
				that.alertMsg = res.data.msg
				that.AlertShow = true
	          return
	        }
	        that.changeCartNum(e.srcElement.dataset.cartid, _num)
	      })
	      
	    },
	// 减少套餐数
	  cutMealNum:function(cartid,num){
		  let that = this
	    if (num>1){
	      let _num = num -1
	      that.$refs.edit.editCartNum(cartid, _num).then((res) => {
	        if (res.data.code == 2) {
	          that.alertMsg = res.data.msg
	          that.AlertShow = true
	          return
	        }
	       that.changeCartNum(cartid, _num)
	      })
	    }
	    
	  },
	  // 增加套餐数
	  addMealNum:function(cartid,num){
		let that = this
	    if (num < 99) {
	      let _num = Number(num) + 1
	      that.$refs.edit.editCartNum(cartid, _num).then((res) => {
			  console.log(res)
	        if (res.data.code == 2) {
	          that.alertMsg = res.data.msg
	          that.AlertShow = true
	          return
	        }
	        that.changeCartNum(cartid, _num)
	      })
	    }
	  },
	// 调整购物橘袋数量
	changeCartNum:function(cartid,num){
		 let _cartInfo = this.cartInfo
				_cartInfo.num = num
			this.cartInfo =  _cartInfo
			this.computeCartDetail(_cartInfo)
	},
	closeAlertShow(){
	  this.AlertShow = false
	},
	getMsgFormSellout(msg){
		this.selloutShow = msg
	},
	// 更改方案
	upPlan: function () {
		this.$refs.edit.getCartDetail(this.cartInfo.id,4);
	},
	// 更改方案后计算
	updateCartList: function (cartid, payMoney,buyDays,planTitle){
	  this.getCartOne(cartid)
	},
	toCreateOrder(returnCartIds){
		let that = this
		if(returnCartIds.length<1){
			this.AlertShow = true
			this.alertMsg = "橘袋没有产品，请重新选择"
			this.axios({
			            method: 'post',
			            url:"Allcart/getCartList",
			            data:{
			               member_id:this.$store.state.member_id 
			            }
			          }).then(res=>{
						  that.getCartOne()
					  })
			
			return
		}
		this.checkGoodsInfo()
	},
	// 检查商品信息是否能创建订单
	checkGoodsInfo: function () {
		let that = this
        let checkCartids =[this.cartInfo.id]	
		this.axios({
				  method: 'post',
				  url:"Allcart/checkCart",
				  data:{
						member_id:this.$store.state.member_id,
						cart_ids: checkCartids,
				  }
		}).then(res=>{
			if (res.data.code == 0) {
			  alert(res.data.msg)
			  return
			}
			if (res.data.code == 3) {   //产品已下架或售罄
				  that.selloutShow=true
				  that.selloutMsg = Object.assign({},{
						msg: res.data.msg,
						msgArr:res.data.msgArr,
						cart_ids: checkCartids,
						msgCode:3
				  })
			}
			if (res.data.code == 2) {   //产品正在预售中
			  that.selloutShow=true
			 that.selloutMsg= Object.assign({},{
								msg: res.data.msg,
								msgArr:res.data.msgArr,
								cart_ids: checkCartids,
								msgCode:2
			 })
			}
			if (res.data.code == 1){
				that.toMadeOrderPage(checkCartids)
			}
		})
	},
	// 调整创建订单页面
	toMadeOrderPage(cartids,secondCheck){
		let _params = { "cartids":cartids}
		
		if(secondCheck){
			_params.secondCheck = true
		}
		
	  this.$router.push({
						name: 'orderMade',
						params: _params
						})
	},
	// 打开修改名字
	  changCartName:function(){
		  console.log("打开修改名字")
	   this.changeNameShow=true
	  
	  },
	  // 确定修改橘袋名
	  changeName:function(){
	    let that = this
	    if (!this.newName)return
		this.axios({
				  method: 'post',
				  url:"Allcart/updateFillName",
				  data:{
						 fill_name: this.newName,
						 cart_id: this.cartid,
				  }
		}).then(res=>{
			
	      if (res.data.code != 1) {
			  that.alertMsg = res.data.msg
			  that.AlertShow = true
	       that.closeChangeName()
	        return
	      }
	      let _cartInfo = that.cartInfo
	      if (res.data.name.length > 8) {
	        res.data.name = res.data.name.substring(0, 7) + "…"
	      }
	      _cartInfo.name = res.data.name
	      that.cartInfo= _cartInfo
	      that.closeChangeName()
	    })

	  },
	  // 关闭修改橘袋名
	  closeChangeName:function(){
	      this.changeNameShow=false
	      this.newName=""
	   
	  },
	  cancelCreateOrder(){
	  		  
	  },
  },
}
</script>  

<style>
#cartDetail{
  background:rgba(244,242,240,1);
  width: 7.5rem;
  height: 100vh;
  position:relative;
  margin: 0 auto;
}
/*#cartDetail::-webkit-scrollbar {display:none}*/

.jdPage{
  width: 7.5rem;
  height:100vh;
  position: relative;
  box-sizing: border-box;
  padding-top: 0.4rem;
  background-color: #fff;
  overflow-y: auto;
}
#cartDetail .jdPage::-webkit-scrollbar {display:none}
.jdTopTips{
  width:7.5rem;
  height:0.66rem;
  background:rgba(246,240,238,1);
}
.jdTopTipsTxt{
  height:0.66rem;
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(183,137,117,1);
  line-height:0.66rem;
  text-align: center;
  letter-spacing: 0.01rem;
}
.jdHead{
  width:6.70rem;
  height:2.77rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 20px 0px rgba(220,207,191,0.6);
  border-radius:0.1rem;
  margin: 0 auto 0.68rem;
  padding: 0.47rem 0.33rem 0 0.37rem;
  box-sizing: border-box;
  border: 0.01rem solid rgba(220,207,191,0.3);
}
.jdHeadTop{
  line-height: 0.48rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.44rem;
}
.jdName{
  font-size:0.48rem;
  font-family:SourceHanSansCN-Bold,SourceHanSansCN;
  font-weight:bold;
  color:rgba(20,20,20,1);
  position: relative;
}
.jdName img{
  position: absolute;
  width: 0.25rem;
  height: 0.25rem;
  top:0;
  right:-0.35rem;
}
.jdTime{
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(153,153,153,1);
}
.jdHeadMid{
  margin-bottom: 0.1rem;
  width: 2rem;
  margin-left:0;
  /* width:140rpx; */
  padding:0 0.2rem;
  border-radius:0.44rem;
  height:0.44rem;
  line-height: 0.44rem;
  border:0.02rem solid rgba(153,153,153,1);
  font-size: 0.26rem;
  
}
.jdHeadMid img{
  width: 0.2rem;
  height: 0.12rem;
  position: relative;
  top:-0.03rem;
  margin-left: 0.05rem;
}
.jdHeadMid span{
  /* background: rgba(20,20,20,0.04);*/
  padding-right: 0.1rem; 
}
.jdHeadMid2{
  height:0.44rem;
  line-height: 0.44rem;
  font-size: 0.26rem;
  display: flex;
  margin-bottom: 0.1rem;
}

.mealbuyday{
  margin-right: 0.2rem;
}
#cartDetail .mealBtn{
  width:0.44rem;
  height:0.44rem;
  box-sizing: border-box;
  line-height: 0.44rem;
  text-align: center;
  border-radius: 0.44rem;
  color: rgba(20, 20, 20, 1);
  font-size: 0.3rem;
  position: relative;
}
#cartDetail .mealBtn .jian{
  width:0.18rem;
  height:0.03rem;
  background:rgba(20,20,20,1);
  border-radius:0.02rem;
  position: absolute;
  top:0.2rem;
  left:0.13rem;
}
#cartDetail .mealBtn .jia{
  width:0.03rem;
  height:0.18rem;
  background:rgba(20,20,20,1);
  border-radius:0.02rem;
  top:-0.08rem;
  left:0.08rem;
  position: absolute;
}
#cartDetail .mealBtn img{
  display: block;
  width:0.44rem;
  height:0.44rem;
}

.mealNumBox{
  padding: 0 0.1rem;
   width: 0.4rem;
   height:0.44rem;
   line-height: 0.44rem;
  display: flex;
  font-size:0.26rem;
}
.mealNumBox input{
  height:0.44rem;
  line-height: 0.44rem;
  width: 0.4rem;
  text-align: center;
  font-size:0.3rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  letter-spacing:0.01rem;
}




.jdHeadBottom{
  height:0.48rem;
  font-size:0.28rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:0.48rem;
  text-align: left;
}
.jdGoodsBox{
  margin-bottom: 0.4rem;
}
.jdGoodsRow{
  padding: 0 0.4rem;
  display: flex;
  min-height: 1.22rem;
  box-sizing: border-box;
  justify-content: space-between;
  margin-bottom: 0.2rem;
  position: relative;
  transition: all 0.3s;
  left: 0;
}

.cover{
  position: absolute;
  left: 0;
  top:0;
  height: 100%;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.6)
}
.jdGoodsRowImg{
  display: block;
  height: 1rem;
  width: 1rem;
  margin-right: 0.24rem;
}
.jdGoodsRowTitle{
  flex: 1;
  display: flex;
  justify-content: space-between;
  border-bottom:0.01rem solid rgba(244,242,240,1);
}
.jdGoodsRowTxt{
  flex: 1;
  text-align: left;
}
.jdGoodsRowName{
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.48rem;
  margin-bottom: 0.16rem;
}
.jdGoodsRowTitle{
  font-size:0.24rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight: 400;
  line-height:0.48rem;
  /* padding-top: 16rpx; */
  color:rgba(194,94,77,1);
}
.jdGoodsRowUse{
  height:0.33rem;
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(51,51,51,1);
  line-height:0.33rem;
}
.goodsRemarks{
   padding-top: 0.16rem;

    font-size:0.24rem;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(194,94,77,1);
    line-height:0.33rem;
    margin-bottom: 0.16rem;
}
.jdGoodsRowPrice{
  width:2rem;
  text-align: right;
  /* line-height: 50rpx;
  font-size:24rpx;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(20,20,20,1);
  letter-spacing:1rpx; */
  color: rgba(16, 16, 16, 1);
  line-height: 0.36rem;
  font-size: 0.24rem;
  padding-top: 0.05rem;
}
.jdGoodsRowPrice span{
  /* font-size:36rpx; */
}
.jdAddGoods{
  padding: 0 0.45rem;
  height: 0.9rem;
  display: flex;
}
.jdAddGoodsImg{
  display: block;
  width: 0.9rem;
  height: 0.9rem;
  margin-right: 0.36rem;
}
.jdAddGoodsTxt{
  line-height: 0.9rem;
  font-size:0.34rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(194,94,77,1);
}
.jdTitle{
  width:4.69rem;
  font-size:0.2rem;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(137,137,137,1);
  line-height:0.28rem;
  text-align: center;
  margin: 0.3rem auto 0.7rem;
}
.jdBottom{
  position: fixed;
  bottom:0;
  left: 50%;
  transform: translate( -50%, 0);  
  width: 7.5rem;
  box-sizing: border-box;
  height: 1.68rem;
  display: flex;
  padding:0.36rem;
  justify-content: space-between;
  background:rgba(255,255,255,1);
  box-shadow:0px -6px 0.2rem 0px rgba(0,0,0,0.08);
}
.jdBottomPayBox{
  text-align: left;
  flex: 1;
}
.jdBottomPay{
  height:0.42rem;
  font-size:0.3rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.33rem;
}
.jdBottomPay span{
  font-size:0.24rem;
}
.jdBottomPayTxt{
  height:0.33rem;
  font-size:0.24rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(155,155,155,1);
  line-height:0.33rem;
}
.jdBottomSure{
  width:20.1rem;
  height:0.88rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 5px 15px 0px rgba(194,94,77,0.25);
  border-radius:0.49rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(194,94,77,1);
  line-height:0.88rem;
  text-align: center;
}
.jdBottomBtn{
  width:2.01rem;
  height:0.88rem;
  background:rgba(194,94,77,1);
  box-shadow:0px 5px 11px -2px rgba(194,94,77,0.4);
  border-radius:0.43rem;
  font-size:0.32rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:0.88rem;
  text-align: center;
}

/* 修改橘袋名 */
.changName{
	position: fixed;
	width: 7.5rem;
	height:100vh;
	top:0;
	left: 50%;
	transform: translate(-50%, 0); 
}
.changNamemask{
  position: absolute;
  z-index: 998;
  width: 7.5rem;
  height:100vh;
  top:0;
  left: 0;
  background:rgba(0, 0, 0, 0.6);
}
.changNameBox{
  width:6.7rem;
  height:5.51rem;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 0.2rem 0px rgba(220,207,191,0.6);
  border-radius:0.1rem;
  position: absolute;
  left: 0.4rem;
  top:3rem;
  z-index: 999;
}
.changNameBoxName{
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium,SourceHanSansCN;
  font-weight:500;
  color:rgba(20,20,20,1);
  line-height:0.72rem;
  padding-top: 0.45rem;
  margin-bottom: 0.2rem;
  text-align: center;
}
.changNameBoxTxt{
  font-size:0.28rem;
  font-family:PingFangSC-Light,PingFang SC;
  font-weight:300;
  color:rgba(80,80,80,1);
  line-height:0.44rem;
  text-align: center;
  padding:0 0.6rem;
  margin-bottom: 0.2rem;
}
.inputBox{
  width:4.6rem;
  height:0.7rem;
  margin: 0 auto;
  border: 0.02rem solid rgb(197, 195, 195);
  border-radius: 0.1rem;
  padding: 0 0.2rem;
  text-align: center;
  margin-bottom: 0.4rem;
}
.changNameBtn1{
    background-color: #C25E4D;
    color: #fff;
    border-radius: 1rem;
    width: 3.02rem;
    line-height: 0.68rem;
    font-size: 0.3rem;
    font-weight: 500;
    margin: 0 auto 0.3rem;
    text-align: center;
    letter-spacing:0.5px;
    box-shadow: 0px 0.16rem 0.25rem -0.05rem rgba(209, 102, 89, 0.2);
}
.changNameBtn2{
    background-color: #fff;
    color: #C25E4D;
    border-radius: 1rem;
    border: 1rpx solid rgba(209, 102, 89, 0.2);
    width: 3.02rem;
    line-height: 0.68rem;
    font-size: 0.3rem;
    font-weight: 500;
    margin: 0 auto;
    text-align: center;
    letter-spacing:0.5rpx;
    box-shadow: 0px 0.16rem 0.25rem -0.05rem rgba(209, 102, 89, 0.2);
}
.nullGoods{
  height: 1.42rem;
  transition: all 0.5s;
}
.nullGoods2{
  height: 0;
}
.delBtn{
  position: absolute;
  top: 0;
  right:-10.2rem;
  width: 10.2rem;
  height: 10.2rem;
  line-height: 10.2rem;
  font-size:0.24rem;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(255,255,255,1);
  background:#C25E4D;
  text-align: center;
  box-sizing: border-box;
  border-radius:0.1rem;
}
.delBtn img{
  width: 0.26rem;
  height: 0.24rem;
  position: relative;
  top:0.05rem;
  margin-right: 0.02rem;
}
.cartDel{
  left: -1.6rem;
}
</style>